import { render } from "./RestaurantSettingsView.vue?vue&type=template&id=1d594079&scoped=true"
import script from "./RestaurantSettingsView.vue?vue&type=script&lang=js"
export * from "./RestaurantSettingsView.vue?vue&type=script&lang=js"

import "./RestaurantSettingsView.vue?vue&type=style&index=0&id=1d594079&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d594079"]])

export default __exports__